
import template from './ko-render-field-number.html';

class NumberInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.readonly = ko.observable();
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.hide_labels = ko.observable(params.hide_labels);
		this.help_text = ko.observable(params.help_text);
		this.min = ko.observable(params.min);
		this.max = ko.observable(params.max);
		this.step = ko.observable(params.step);
		this.required = ko.observable(false);

		this.$input = params.$input || ko.observable();

		if (params.ui_fields)
		{
			if (params.ui_fields.min !== undefined) this.min(params.ui_fields.min);
			if (params.ui_fields.max !== undefined) this.max(params.ui_fields.max);
			if (params.ui_fields.step !== undefined) this.step(params.ui_fields.step);
			if ((this.$input() == null || this.$input() === '') && params.ui_fields.default !== undefined)
				this.$input(params.ui_fields.default);
			if (params.ui_fields.required)
				this.required(params.ui_fields.required);
		}
		else
		{
			if (params.default !== undefined && (this.$input() == null || this.$input() === ''))
				this.$input(params.default);
			if (params.required)
				this.required(params.required);
		}
	}

	// Clamp function to be called on blur
	clamp_value()
	{
		let value = parseFloat(this.$input());
		if (isNaN(value)) return;

		const min = parseFloat(this.min());
		const max = parseFloat(this.max());
		const step = parseFloat(this.step());

		// Clamp to min and max
		if (value < min)
		{
			this.$input(min);
			return;
		}

		if (value > max)
		{
			this.$input(max);
			return;
		}

		const steps_from_min = Math.round((value - min) / step);
		const corrected = min + steps_from_min * step;

		const decimals = (step.toString().split('.')[1] || '').length;
		const rounded = parseFloat(corrected.toFixed(decimals));

		this.$input(rounded);
	};
}

export default {
	name: 'ko-render-field-number',
	viewModel: NumberInputComponentVM,
	module_type: 'ko',
	template: template
}

